import React from 'react';

interface FooterImageProps {
    footerImage?: string;
    footerSmallImage?: string;
    experiments?: any;
}

export class FooterImage extends React.PureComponent<FooterImageProps> {
    render() {
        const { footerImage, footerSmallImage } = this.props;

        let component = null;

        if (footerImage && footerSmallImage) {
            component = (
                <div className="branding-image-container eds-align--center-horizontal eds-l-mar-top-20">
                    <img
                        srcSet={`
                                ${footerSmallImage} 512w,
                                ${footerImage} 1272w
                            `}
                        sizes="
                                (max-width: 512px) 200vw,
                                1272px
                            "
                        src={footerImage}
                        alt=""
                        className="branding-image-container__footer-image"
                        loading="lazy"
                    />
                </div>
            );
        }

        return component;
    }
}
